import axios from "axios";
import { ACCOUNT_INFORMATION_URL } from "../utils";

export const fetchAccountInformation = async () => {
  return await axios.get(ACCOUNT_INFORMATION_URL);
};
